import clsx from 'clsx';
import { FC } from 'react';

interface Props {
  width?: number;
  height?: number;
  className?: string;
}

export const BackpackIcon: FC<Props> = ({
  className,
  width = 135,
  height = 135,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 135 135"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx('backpack-icon', className)}
      aria-hidden="true"
      focusable="false"
    >
      <g id="Group 2 Copy">
        <g id="top left buttons copy 10">
          <g id="button/exit">
            <g id="exit">
              <circle
                id="Oval"
                cx="67.2"
                cy="67.5"
                r="67.2"
                fill="#FFC700"
                fillOpacity="0.5"
              />
            </g>
          </g>
        </g>
        <g id="Group">
          <g id="Group 56 Copy">
            <rect
              id="Rectangle"
              x="59.9996"
              y="26.7"
              width="14.4"
              height="21.6"
              rx="7.2"
              stroke="#258569"
              strokeWidth="4.8"
            />
            <rect
              id="Rectangle_2"
              x="28.7998"
              y="72.3"
              width="76.8"
              height="24"
              rx="7.2"
              fill="#45AC60"
            />
            <path
              id="Rectangle_3"
              d="M36 57.9C36 44.6452 46.7452 33.9 60 33.9H74.4C87.6548 33.9 98.4 44.6452
              98.4 57.9V98.7C98.4 102.676 95.1765 105.9 91.2 105.9H43.2C39.2235 105.9 36 102.676 36 98.7V57.9Z"
              fill="#258569"
            />
            <path
              id="Rectangle_4"
              d="M48 72.3H86.4V86.7C86.4 92.002 82.1019 96.3 76.8 96.3H57.6C52.2981 96.3 48 92.002 48 86.7V72.3Z"
              fill="#45AC60"
            />
            <rect
              id="Rectangle Copy 11"
              x="48"
              y="48.3"
              width="38.4"
              height="9.6"
              rx="4.8"
              fill="#45AC60"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
